<template>
  <div class="home">
    <iframe v-if="this.$route.name==='viewer'"  class="mt-1" frameborder="0"  scrolling="auto" style="width:100%; height:100%;" :src="`https://livetour.istaging.com/${this.$route.params.id}`"></iframe>
    <vr-player v-else :id="$route.params.id" />
  </div>
</template>

<script>
import VrPlayer from '../components/VrPlayer'

export default {

  name: 'Viewer',

  components: {
    VrPlayer
  },
  mounted () {
    console.log(this.$route.name)
  }
}
</script>

<style lang="scss" scoped>
.home {
  height: 100vh;
  width: 100%;
}
</style>
